/** @jsxImportSource react */
import React from 'react';
import logoImage from './casprlogo.png'; // Adjust path and filename

export const CasprLogo = ({ className = "h-8" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoImage} 
        alt="Logo"
        style={{ height: '40px' }} // Adjust size as needed
      />
      <span className="text-xl font-bold text-gray-900">CASPR</span>
    </div>
  );
}; 